import toString from './to-string';
var upperFirst = function (value) {
  var str = toString(value);
  return str.charAt(0).toUpperCase() + str.substring(1);
};
export default upperFirst;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/upper-first.js
// module id = 84
// module chunks = 0